import { Link, useParams } from "react-router-dom";
import Lizenz from "../Lizenz.jsx";

export default function ArchiveSeasonLizenzDb() {
    const { seasonKey } = useParams();
    const key = String(seasonKey || "").trim() || "active";

    return (
        <>
            <div className="card" style={{ marginBottom: 12 }}>
                <h2 style={{ marginBottom: 8 }}>Archiv Fahrerlizenz - {key.toUpperCase()}</h2>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Link className="btn" to={`/gt3x/archiv/${key}`}>Zur Season</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/results`}>Results</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/incidents`}>Incidents</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/pro`}>PRO</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/int`}>INT</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/am`}>AM</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/team`}>TEAM</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/marke`}>MARKE</Link>
                </div>
            </div>

            <Lizenz
                seasonKey={key}
                title={`Archiv Fahrerlizenz (${key})`}
                subtitle="Archivierte Lizenzpunkte und Strafstatus dieser Saison."
            />
        </>
    );
}